// Cifra de "Entregados" a partir de la respuesta de `reports/dashboard/packages-resume`.
//
// `delivered` cuenta por fecha de entrega (`deliveryData.deliveredAt`), igual que el
// Informe de Entregas. `status4` cuenta por `updatedAt`, que la facturación reescribe
// a todo lo que factura, así que mueve entregas de un período a otro: solo se usa si
// el backend todavía no manda `delivered` (deploys de front y back por separado).
//
// Devuelve `null` cuando el backend no pudo contar las entregas: la vista debe
// mostrarlo como "sin dato", nunca como 0.
export function deliveredFromResume(resume) {
  if (resume?.delivered === undefined) return resume?.status4 ?? 0;
  return resume.delivered;
}
